import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { hasPermission, user } = useAuth();

  return {
    hasPermission,
    permissions: user?.permissions || [],
    loading: false,
    error: null
  };
}; 